import { Component,OnInit,Input,Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MapfreButtonComponent, MapfreModalComponent, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PolicyDetailsService } from '../../../../../_services/my-insurance/policy-details.service';
import { TranslatePipe } from '@ngx-translate/core';
@Component({
  selector: 'app-mortgagee-modal',
  templateUrl: './mortgagee-modal.component.html',
  styleUrls: ['./mortgagee-modal.component.scss'],
  imports: [TranslatePipe, MapfreButtonComponent, MapfreModalComponent]
})
export class MortgageeModalComponent implements OnInit {
  
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @Input() policy;
  @Input() isPaidInFullPending?: boolean = false;
  isOpen = false;
  isAcmic: boolean;
  mortgageeModalOptions: ModalOptions;
  hideModal = false;
  isMortgagee: boolean;

  constructor(private router: Router, private policyDetailsService: PolicyDetailsService) {}  
  
 ngOnInit(): void {
    this.triggerModal();
    this.isMortgagee = this.policy?.billingDetails?.[0]?.mortageeFlag === 'Y' &&
      this.policy?.billingDetails?.[0]?.outstandingbalance > 0
  }

  triggerModal() {
    this.mortgageeModalOptions = new ModalOptions({
      additionalButtonClasses: 'basic primary bn-paynow-action-btn',
      additionalClasses:
        'mortgagee-modal pay-now-modal modal-medium modal-dialog center-on-page modal-dialog-scrollable',
      buttonCopy: '',
      modalId: 'mortgageeModal',
      modalTranslateCopy: `${this.isAcmic ? 'MORTGAGEE_MODAL_MESSAGE' : ''}`,
      onLoad: true,
      size: 'modal-medium',
      typeOfModal: 'default',
      modalName: 'mortgagee_modal'
    });
  }

  
 callHide(): void {
    this.hideModal = !this.hideModal;
    this.closeModal.emit(true);
  }
  resetHideModal(): void {
    this.callHide();
  }

   hideOnClick(event) {
    if (!event.target.closest('.modal-overlays')) {
      this.resetHideModal();
    }
  }

  cancelModal(event) {
    if (event) {
      this.resetHideModal();
    }
  }

  onProceed(): void {
    this.router.navigate([
      'billing-new',
      this.policy?.policynumber?.policyNumber,
      'make-a-payment',
    ]);
  }
}